export const addDelegation = async (client, data, params, url="/delegations") => {
    try {
        return await client.post(url, data, params);
    } catch(err) {
        console.warn(err);
        throw err;
    }
};
